import React from "react";

class ChangingProgressProvider extends React.Component {
  static defaultProps = {
    interval: 33,
  };

  state = {
    valuesIndex: 0,
    value:0
  };

  componentDidMount() {
    if(this.props.isOnAnimation)
    {
     var x=  setInterval(() => {
       if(this.props.isActive)
       {
        this.setState({
          value: ((100.0/(1000.0/this.props.interval))/this.props.time)*this.state.valuesIndex,
          valuesIndex: this.state.valuesIndex+1
        });
        if(this.state.value > 100)
        {
          this.props.onAnimationFinish();
          clearInterval(x);
        }
      }
      }, this.props.interval);
      
    } 
    else{
      this.setState({value:100});
    }

   }

  render() {
    return this.props.children(this.state.value);
  }
}

export default ChangingProgressProvider;
